import React from "react";
import { Link } from "react-router-dom";
import { HeaderAsociacion } from "../componentes/headerAsociacion";
import { CustomFooter } from "../componentes/footer";
import { FranjaFija } from "../componentes/franjaFija";

export const PoliticasPrivacidad = () => {
  return (
    <>
      <HeaderAsociacion grande>
        <Link to="/" className="header-asoc-enlace">
          Inicio
        </Link>
      </HeaderAsociacion>

      <FranjaFija izq="#D9D9D9">
      <section className="pagina-legal">
        <h1>Política de Privacidad</h1>
        <p><strong>Fase Cuatro S.A.S.</strong></p>
        <p><em>Última actualización: 14 de abril de 2025</em></p>
        <p><em>Jurisdicción: República Argentina</em></p>

        <h2>1. Introducción</h2>
        <p>
          En <strong>Fase Cuatro S.A.S.</strong> valoramos y respetamos la privacidad de nuestros usuarios.
          Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos tus datos personales
          cuando utilizás nuestra aplicación móvil destinada a pilotos que participan en competencias.
        </p>

        <h2>2. Datos que Recopilamos</h2>
        <p>Podemos recopilar y tratar los siguientes datos personales:</p>
        <ul>
          <li>Nombre y apellido.</li>
          <li>Correo electrónico.</li>
          <li>Número de documento o identificación del piloto.</li>
          <li>Datos relacionados con las carreras: resultados, clasificaciones y rendimiento.</li>
        </ul>
        <p>No recopilamos datos sensibles, financieros ni de geolocalización.</p>

        <h2>3. Finalidad del Tratamiento</h2>
        <p>
          Los datos se utilizan con el fin exclusivo de brindar acceso a la plataforma,
          mostrar resultados y estadísticas personalizadas, y mantener una correcta identificación del usuario.
        </p>

        <h2>4. Base Legal</h2>
        <p>
          El tratamiento de tus datos se basa en el consentimiento que otorgás al utilizar la aplicación,
          conforme a lo establecido por la Ley N.º 25.326 de Protección de Datos Personales en la República Argentina.
        </p>

        <h2>5. Almacenamiento y Seguridad</h2>
        <p>
          Tus datos se almacenan en servidores seguros y adoptamos medidas técnicas y organizativas adecuadas
          para protegerlos contra accesos no autorizados, pérdida o modificación.
        </p>

        <h2>6. Cesión de Datos</h2>
        <p>
          No compartimos tus datos personales con terceros, salvo que exista obligación legal o requerimiento judicial.
          En ningún caso se venden ni ceden datos con fines comerciales.
        </p>

        <h2>7. Derechos del Usuario</h2>
        <p>
          Tenés derecho a acceder, rectificar, actualizar, suprimir y oponerte al tratamiento de tus datos personales.
          Para ejercer estos derechos, podés escribirnos a <a href="mailto:contacto@fasecuatro.com">contacto@fasecuatro.com</a>.
        </p>

        <h2>8. Retención de Datos</h2>
        <p>
          Conservaremos tus datos únicamente durante el tiempo necesario para cumplir con los fines del servicio.
          Podés solicitar la eliminación de tu cuenta y sus datos en cualquier momento.
        </p>

        <h2>9. Menores de Edad</h2>
        <p>
          La aplicación está dirigida a personas mayores de 16 años. Si sos menor de edad, necesitás autorización de tus padres o tutores.
        </p>

        <h2>10. Cambios en la Política de Privacidad</h2>
        <p>
          Esta política puede ser actualizada ocasionalmente. Te notificaremos cualquier cambio relevante
          mediante la aplicación o nuestro sitio web.
        </p>

        <h2>11. Contacto</h2>
        <p>
          Si tenés dudas o consultas sobre esta Política de Privacidad, podés comunicarte con nosotros:
          <br />
          📧 <a href="mailto:info@fasecuatro.com.ar">contacto@fasecuatro.com.ar</a><br />
          🌐 <a href="https://fasecuatro.com.ar" target="_blank" rel="noopener noreferrer">https://fasecuatro.com.ar</a>
        </p>
      </section>
      </FranjaFija>

      <CustomFooter />
    </>
  );
};
